/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chain_Page_Compare_Metric_Theor_TpsInputs */



/**
* | output |
* | --- |
* | "max theoretical TPS" |
*
* @param {Chain_Page_Compare_Metric_Theor_TpsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const chain_page_compare_metric_theor_tps = /** @type {((inputs?: Chain_Page_Compare_Metric_Theor_TpsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chain_Page_Compare_Metric_Theor_TpsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("max theoretical TPS")
});